import { useState } from "react";
import { Tooltip, TooltipProvider } from "../../components/ui/Tooltip";
import { Star, X } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";

// ✅ Reusable modal
const Modal = ({ open, onClose, title, children }) => (
  <AnimatePresence>
    {open && (
      <motion.div
        className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-md p-4"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.3 }}
      >
        <motion.div
          initial={{ scale: 0.95, opacity: 0, y: 30 }}
          animate={{ scale: 1, opacity: 1, y: 0 }}
          exit={{ scale: 0.95, opacity: 0, y: 30 }}
          transition={{ type: "spring", stiffness: 300, damping: 25 }}
          className="relative bg-white rounded-2xl shadow-xl max-w-lg w-full p-6 sm:p-8"
        >
          <div className="flex justify-between items-center mb-6">
            <h2 className="text-xl sm:text-2xl font-bold text-gray-900">
              {title}
            </h2>
            <button
              onClick={onClose}
              className="p-2 rounded-full hover:bg-gray-100 transition-colors focus:outline-none focus:ring-2 focus:ring-yellow-500"
            >
              <X className="h-5 w-5 text-gray-500 hover:text-gray-700" />
            </button>
          </div>
          <div className="text-gray-600 text-sm sm:text-base leading-relaxed">
            {children}
          </div>
          <div className="flex justify-end mt-6">
            <button
              onClick={onClose}
              className="px-4 py-2 text-sm font-medium bg-gradient-to-r from-yellow-500 to-orange-500 text-white rounded-lg shadow-md hover:scale-105 transition-transform"
            >
              Close
            </button>
          </div>
        </motion.div>
      </motion.div>
    )}
  </AnimatePresence>
);

const VIPMemberTooltip_v2 = () => {
  const [open, setOpen] = useState(false);

  const content = (
    <div className="max-w-xs sm:max-w-md text-sm sm:text-base space-y-4">
      <p className="text-white-700 leading-relaxed">
        <strong>VIP Members</strong> are our priority clients who receive
        enhanced assistance and faster service coordination across our hospital
        and clinic network.
      </p>
      <ul className="list-disc pl-5 space-y-2 text-white-600">
        <li>Priority access during hospital admission and approvals.</li>
        <li>Dedicated customer care through AMAPHIL’s support line.</li>
        <li>Exclusive health plan options and faster claims turnaround.</li>
      </ul>
      <p className="text-white-700">
        As the first ISO 9001:2015-certified TPA in the Philippines, AMAPHIL
        ensures that our VIP members receive{" "}
        <strong>seamless, technology-powered healthcare access</strong>.
      </p>
    </div>
  );

  return (
    <>
      <TooltipProvider>
        <Tooltip content={content}>
          <div
            className="inline-flex items-center px-2 py-1 rounded-full text-xs font-semibold bg-gradient-to-r from-yellow-400 via-yellow-500 to-orange-500 text-white shadow-md hover:shadow-lg transform hover:scale-105 transition-all duration-300 cursor-pointer"
            onClick={() => setOpen(true)}
          >
            <Star className="h-4 w-4 mr-1 text-yellow-200 drop-shadow-md animate-pulse" />
            VIP
          </div>
        </Tooltip>
      </TooltipProvider>

      <Modal open={open} onClose={() => setOpen(false)} title="VIP Member Benefits">
        {content}
      </Modal>
    </>
  );
};

export default VIPMemberTooltip_v2;
